import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProxyContext } from '../enums/proxy-context.enum';
import { MenuOption } from '../models/menu-option.model';
import { HttpServerResponse } from '../models/response.model';
import { HttpRequestService } from './http-request.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menuData = new BehaviorSubject<MenuOption[]>([]);

  constructor(private readonly _httpRequestService: HttpRequestService) {}

  /**
   * Obtains the menu data for app
   *
   * @param command - Data with parameters
   * @returns - Returns menu object
   */
  getMenu(): Observable<HttpServerResponse<MenuOption[]>> {
    return this._httpRequestService.post<MenuOption[]>(ProxyContext.GetMenu);
  }

  emitMenu(data: MenuOption[]) {
    this.menuData.next(data);
  }
}
